import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { SelectButton } from 'primereact/selectbutton';
import { Divider } from 'primereact/divider';
import { Fieldset } from 'primereact/fieldset';
import { TravelStatus } from '../../common/util/constants';
import { travelService } from '../../services/extensions';
import { toast } from 'react-toastify';
import { capitalize } from '../../services/utility/helper';
import { Dialog } from 'primereact/dialog';
import { Card } from 'react-bootstrap';
import { Panel } from 'primereact/panel';
import { Timeline } from 'primereact/timeline';
import moment from 'moment';
const CeoTeamRequestApproval = () => {
    const [selectedLeave, setSelectedLeave] = useState([]);
    const [leaveInReview, setLeaveInReview] = useState([]);
    const [visible, setVisible] = useState(false);
    const [selectedTravelRecord, setSelectedTravelRecord] = useState(null);
    const [rejectDialogVisible, setRejectDialogVisible] = useState(false);
    const [rejectReason, setRejectReason] = useState('');
    useEffect(() => {
        fetchInReviewTravels();
    }, []);

    const fetchInReviewTravels = async () => {
        try {
            const resp = await travelService.getUserReviewtravelByTr();
            const filteredData = resp.data.data.filter(item =>
                item.Travels.some(travel =>
                    [TravelStatus.APPROVED_BY_BU_HEAD,  TravelStatus.APPROVED_BY_HR_HEAD,TravelStatus.APPROVED_BY_CEO].includes(travel.status)
                )
            );
            setLeaveInReview(filteredData);
        } catch (error) {
            toast.error('Error fetching data');
        }
    };

    const requestedDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            return moment(rowData.Travels[0].createdAt).format('DD/MM/YYYY');
        }
        return 'N/A';
    };

    const journeyDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            return rowData.Travels[0].journeyDate ? moment(rowData.Travels[0].journeyDate).format('DD/MM/YYYY') : 'N/A';
        }
        return 'N/A';
    };

    const userNameTemplate = (rowData) => {
        return `${rowData.firstName} ${rowData.lastName}`;
    };

    const Designationtitle = (rowData) => {
        return <div>
            <p>{rowData.Designation?.title || 'N/A'}</p>
        </div>
    };

    const BusinessUnittitle = (rowData) => {
        return <div>
            <p>{rowData.BusinessUnit?.title || 'N/A'}</p>
        </div>
    };

    const projectBodyTemplate = (rowData) => {
        return (
            <>
                {rowData.Allocations?.map(allocation => (
                    <div key={allocation.id}>
                        {allocation.Project?.title || 'N/A'} ({allocation.percentage}%)
                    </div>
                ))}
            </>
        );
    };

    const approvesingleRecord = async (rowData) => {
        let param = {
            travels: rowData.Travels.map((e) => e.id),
            status: TravelStatus.APPROVED_BY_CEO
        };
        try {
            await travelService.ApproveRejecttravelBulk([param]);
            setSelectedLeave([]);
            fetchInReviewTravels();
            toast.success('Record approved successfully');
        } catch (error) {
            toast.error('Error approving record');
        }
    };

    const rejectsingleRecord = (rowData) => {
        setSelectedTravelRecord(rowData);
        setRejectDialogVisible(true);
    };
    // const rejectsingleRecord = async (rowData) => {
    //     let param = {
    //         travels: rowData.Travels.map((e) => e.id),
    //         status: TravelStatus.REJECTED_BY_CEO
    //     };
    //     try {
    //         await travelService.ApproveRejecttravelBulk([param]);
    //         setSelectedLeave([]);
    //         fetchInReviewTravels();
    //         toast.success('Record rejected successfully');
    //     } catch (error) {
    //         toast.error('Error rejecting record');
    //     }
    // };

    const actionBody = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-check" className="p-button-rounded p-button-primary mr-2" onClick={() => approvesingleRecord(rowData)} />
                <Button icon="pi pi-times" className="p-button-rounded p-button-danger mr-2" onClick={() => rejectsingleRecord(rowData)} />
                <Button icon="pi pi-eye" className="p-button-rounded p-button-secondary mr-2" onClick={() => handleViewDetail(rowData)} />
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <SelectButton
                />
            </React.Fragment>
        );
    };

    const approveLeave = async (selectedLeave) => {
        let idList = [];
        selectedLeave?.map(x => x.Travels?.map(y => {
            idList.push(y.id);
        }));
        let param = {
            travels: idList,
            status: TravelStatus.APPROVED_BY_CEO
        };
        try {
            await travelService.ApproveRejecttravelBulk([param]);
            toast.success(capitalize(selectedLeave[0].firstName) + " " + capitalize(selectedLeave[0].lastName) + " travels have been approved");
            setSelectedLeave([]);
            fetchInReviewTravels();
        } catch (error) {
            toast.error('Error approving records');
        }
    };


    const rejectLeave = async (selectedLeave) => {
        let idList = [];
        selectedLeave?.map(x => x.Travels?.map(y => {
            idList.push(y.id);
        }));
        let param = {
            travels: idList,
            status: TravelStatus.REJECTED_BY_CEO,
            reason: "rejected"
        };
        try {
            await travelService.ApproveRejecttravelBulk([param]);
            toast.error(capitalize(selectedLeave[0].firstName) + " " + capitalize(selectedLeave[0].lastName) + " travels have been rejected");
            setSelectedLeave([]);
            fetchInReviewTravels();
        } catch (error) {
            toast.error('Error rejecting records');
        }
    };

    const handleViewDetail = (rowData) => {
        setSelectedTravelRecord(rowData);
        setVisible(true);
    };

    return (
        <>
            <div className="col-12">
                <div className="tabview-demo col-12">
                    <Fieldset>
                        <h1>Team Members - Awaiting Approvals</h1>
                        <Divider />
                        <div className="formgrid grid mt-4">
                            <div className="field col-2">
                                <Button label="Approve All"
                                    className="w-100"
                                    style={{ marginRight: "10px" }}
                                    onClick={() => approveLeave(selectedLeave)}
                                    disabled={selectedLeave.length === 0}
                                />
                            </div>
                            <div className="field col-2">
                                <Button label="Reject All"
                                    className="p-button-danger w-100"
                                    onClick={() => rejectLeave(selectedLeave)}
                                    disabled={selectedLeave.length === 0}
                                />
                            </div>
                            <div className="field col-8">
                                <div style={{ textAlign: "right" }}>
                                    {rightToolbarTemplate()}
                                </div>
                            </div>
                        </div>

                        <DataTable
                            className="mt-4 travels-data"
                            paginator
                            responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            dataKey="id"
                            value={leaveInReview}
                            selection={selectedLeave}
                            onSelectionChange={(e) => setSelectedLeave(e.value)}
                            resizableColumns
                            columnResizeMode="fit"
                            scrollable="horizontal"
                            stripedRows
                            editMode="row"
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: "10px" }}></Column>
                            <Column header="Requested Date" body={requestedDateTemplate} />
                            <Column header="ECN" field='ecn' />
                            <Column header="User Name" body={userNameTemplate} />
                            <Column header="Designation" body={Designationtitle} />
                            <Column header="BU" body={BusinessUnittitle} />
                            <Column header="Project" body={projectBodyTemplate} />
                            <Column header="Travel Date" body={journeyDateTemplate} />
                            <Column header="Action" body={actionBody} />
                        </DataTable>
                    </Fieldset>
                    <Dialog
                        header="Reject Reason"
                        visible={rejectDialogVisible}
                        style={{ width: '50vw' }}
                        onHide={() => setRejectDialogVisible(false)}
                    >
                        <div className="p-field">
                            <label htmlFor="rejectReason">Reason</label>
                            <textarea
                                id="rejectReason"
                                rows="5"
                                value={rejectReason}
                                onChange={(e) => setRejectReason(e.target.value)}
                                className="p-inputtextarea"
                            />
                        </div>
                        <div className="p-d-flex p-jc-end">
                            <Button
                                label="Reject"
                                icon="pi pi-times"
                                className="p-button-danger"
                                onClick={() => {rejectLeave([selectedTravelRecord]);
                                    setRejectDialogVisible(false);
                                }}
                                disabled={!rejectReason.trim()}
                            />
                            <Button
                                label="Cancel"
                                icon="pi pi-times"
                                className="p-button-text"
                                onClick={() => setRejectDialogVisible(false)}
                            />
                        </div>
                    </Dialog>
                    <Dialog header="Travel Detail" visible={visible} style={{ width: '95vw' }} onHide={() => setVisible(false)}>
                        <div>
                            <div className="flex flex-column w-70">
                                {/* <Timeline value={progressStatus} layout="horizontal" align="bottom" content={(item) => item} opposite={<span>&nbsp;</span>} /> */}
                            </div>
                            {selectedTravelRecord && selectedTravelRecord.Travels && selectedTravelRecord.Travels.map((travel, index) => (
                                <Panel key={travel.id} className='traveldetail'>
                                    <div className='formgrid grid'>
                                        <div className='col-12'>
                                            <Card>
                                                <div className='d-flex-space-bet'>
                                                    <h1>Traveler Detail {index + 1}</h1>
                                                </div>
                                                <div className="formgrid grid">
                                                    <div className='field col-2 single-category'>
                                                        <h2>Trip Type</h2>
                                                        <p>{travel.tripTypeInfo?.title || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Visa Type</h2>
                                                        <p>{travel.visaTypeInfo?.title || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>User ECN</h2>
                                                        <p>{travel.empEcn || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Manager ECN</h2>
                                                        <p>{travel.managerEcn || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Traveller Name</h2>
                                                        <p>{selectedTravelRecord.firstName} {selectedTravelRecord.lastName}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Traveller Initiated By</h2>
                                                        <p>{travel.createdBy || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Surname</h2>
                                                        <p>{selectedTravelRecord.lastName}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>User Name</h2>
                                                        <p>{selectedTravelRecord.firstName}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Designation</h2>
                                                        <p>{selectedTravelRecord.Designation?.title || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Mobile Number</h2>
                                                        <p>{selectedTravelRecord.phone || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-4 single-category'>
                                                        <h2>Email ID</h2>
                                                        <p>{selectedTravelRecord.email || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Grade</h2>
                                                        <p>{travel.grade || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-6 single-category'>
                                                        <h2>Traveller Comments</h2>
                                                        <p>{travel.comment || 'N/A'}</p>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                        <div className='col-12'>
                                            <Card>
                                                <div className='d-flex-space-bet'>
                                                    <h1>Traveller Detail</h1>
                                                </div>
                                                <div className="formgrid grid">
                                                    <div className='field col-2 single-category'>
                                                        <h2>Client Name</h2>
                                                        <p>{travel.clientId || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Project Name</h2>
                                                        <p>{travel.projectId || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Project Manager</h2>
                                                        <p>{travel.managerEcn || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>BU/Functional Head</h2>
                                                        <p>{travel.buHead || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Country of Visit</h2>
                                                        <p>{travel.countryofVisit || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>State/Cities</h2>
                                                        <p>{travel.states || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Journey Date</h2>
                                                        <p>{travel.journeyDate ? moment(travel.journeyDate).format('DD/MM/YYYY') : 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Return Date</h2>
                                                        <p>{travel.returnDate ? moment(travel.returnDate).format('DD/MM/YYYY') : 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Cost Center</h2>
                                                        <p>{travel.costCenter || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>DA Currency</h2>
                                                        <p>{travel.daCurrency || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>DA Entitle Amount</h2>
                                                        <p>{travel.daentitleAmmount || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Seat Request</h2>
                                                        <p>{travel.seatRequest || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Meal Request</h2>
                                                        <p>{travel.mealRequest || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-6 single-category'>
                                                        <h2>Frequently Flyer Number</h2>
                                                        <p>{travel.frequentflyerNumber || 'N/A'}</p>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                        <div className='col-12'>
                                            <Card>
                                                <div className='d-flex-space-bet'>
                                                    <h1>Passport Detail</h1>
                                                </div>
                                                <div className="formgrid grid">
                                                    <div className='field col-2 single-category'>
                                                        <h2>Passport Number</h2>
                                                        <p>{travel.travelDetails?.[0]?.passportNumber || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Date of Birth</h2>
                                                        <p>{travel.travelDetails?.[0]?.dateOfBirth ? moment(travel.travelDetails[0].dateOfBirth).format('DD/MM/YYYY') : 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Place of Issue</h2>
                                                        <p>{travel.travelDetails?.[0]?.placeOfIssue || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Issue of Passport</h2>
                                                        <p>{travel.travelDetails?.[0]?.dateOfIssueOfPassport ? moment(travel.travelDetails[0].dateOfIssueOfPassport).format('DD/MM/YYYY') : 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-2 single-category'>
                                                        <h2>Expire In Passport</h2>
                                                        <p>{travel.travelDetails?.[0]?.dateOfexpireOfPassport ? moment(travel.travelDetails[0].dateOfexpireOfPassport).format('DD/MM/YYYY') : 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-6 single-category'>
                                                        <h2>Address as per the Passport</h2>
                                                        <p>{travel.travelDetails?.[0]?.addressAsPerthefPassport || 'N/A'}</p>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                        <div className='col-12'>
                                            <Card>
                                                <div className='d-flex-space-bet'>
                                                    <h1>Insurance Detail</h1>
                                                </div>
                                                <div className="formgrid grid">
                                                    <div className='field col-4 single-category'>
                                                        <h2>Current Residence Address</h2>
                                                        <p>{travel.travelDetails?.[0]?.currentResidenceAddress || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-4 single-category'>
                                                        <h2>Nominee Name</h2>
                                                        <p>{travel.travelDetails?.[0]?.nomineeName || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-4 single-category'>
                                                        <h2>Relation With Nominee</h2>
                                                        <p>{travel.travelDetails?.[0]?.relationWithNominee || 'N/A'}</p>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                    </div>
                                </Panel>
                            ))}
                        </div>
                    </Dialog>
                </div>
            </div>
        </>
    );
};

export default CeoTeamRequestApproval;
